import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';

import { Form, Input, Icon } from 'semantic-ui-react';
import { Button } from 'components';

import classNames from 'classnames/bind';
import styles from './CheckEmail.css';
const cx = classNames.bind(styles);

/* 이메일 확인 컴포넌트 */
class CheckEmail extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { send, handleChangeCE, handleKeyPressCE, checkEmail, errorMessage } = this.props;

    return (
      <div className={cx('checkEmail', 'content-inner')}>
        <div className={cx('comment-area')}>
          <div className={cx('comment-title')}>
            {defineMessages(formatMessage({ id: 'CheckEmail_1', defaultMessage: '비밀번호 찾기' }))}
          </div>
          <div className={cx('comment-content')}>
            <div className={cx('dark-grey', 'font-size-12')}>
              {defineMessages(
                formatMessage({
                  id: 'CheckEmail_7',
                  defaultMessage: '해당 이메일로 비밀번호 재설정 링크를 보내드립니다.'
                })
              )}
            </div>
          </div>
        </div>
        <Form>
          <div className={cx('wrap-input')}>
            <Form.Input
              className={cx('login-input')}
              type="text"
              name="userEmail"
              placeholder={defineMessages(formatMessage({ id: 'CheckEmail_4', defaultMessage: '이메일' }))}
              onChange={handleChangeCE}
              onKeyPress={handleKeyPressCE}
              // error={!!errorMessage}
              autoComplete="off"
            />
          </div>
          {/* 로그인 실패시 에러 메세지 */}
          <div className={cx('error-message ml-10')}>{!!errorMessage && errorMessage}</div>
          <div className={cx('button-area')}>
            <Button className={cx('bt-brand')} onClick={checkEmail}>
              {defineMessages(formatMessage({ id: 'CheckEmail_6', defaultMessage: '확인' }))}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

CheckEmail.propTypes = {
  send: ImmutablePropTypes.mapContains({
    isExist: PropTypes.number,
    isSend: PropTypes.number,
    resultMessage: PropTypes.string
  }),
  handleChangeCE: PropTypes.func,
  handleKeyPressCE: PropTypes.func,
  checkEmail: PropTypes.func
};

export default injectIntl(CheckEmail);



// WEBPACK FOOTER //
// ./src/script/components/pwReset/CheckEmail.js